import React from "react";
import {Grid, InputAdornment, Typography} from "@material-ui/core";
import TextField from "../molecules/TextField";
import {css} from "@emotion/react";
import SearchIcon from "@material-ui/icons/Search";
import InputField from "../atoms/InputField";

export const EnergyField = React.memo(() => {
  return (
      <>
        <Grid container flexDirection={'row'} alignItems='center'>
          <Grid item flexShrink={4} css={{width: 'auto', margin: '0 4px 0 2px'}}>
            <Typography><span>エネルギー</span></Typography>
          </Grid>
          <Grid item flexShrink={1} css={itemStyle}>
            <InputField
                type={'number'}
                id='energy_lower'
                name='energy[lower]'
                placeholder='下限'
                css={fieldStyle}
                wrapperCss={{margin: '4px'}}
            />
          </Grid>
          <Grid item flexShrink={4} css={{margin: '0 4px 0 2px'}}>
            <span>〜</span>
          </Grid>
          <Grid item flexShrink={1} css={itemStyle}>
            <InputField
                type={'number'}
                id='energy_upper'
                name='energy[upper]'
                placeholder='上限'
                css={fieldStyle}
                wrapperCss={{margin: '4px'}}
            />
          </Grid>
          <Grid item flexShrink={4}>
            <span><span>kcal</span></span>
          </Grid>
        </Grid>
      </>
  )
})

EnergyField.displayName = 'EnergyField'

const fieldStyle = css`
  width: 100%;
`

const itemStyle = css`
  width: 7.5rem;
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type="number"] {
    -moz-appearance:textfield;
  }
`